import { requester } from '../utils';

export const getSalesReport = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/sales-report?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
